import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { monthNames } from "../../assets/menu";
import { getSingleCourse } from "../../services";
import { ArrowBack } from "@mui/icons-material";
import EastIcon from "@mui/icons-material/East";
import Divider from "@mui/material/Divider";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import { setWordCase } from "../../assets/library";
import Images from "../../assets";
import CustomTabs from "../../components/tabs";

const CourseDetailed = (props: any) => {
  const [singleCourseData, setSingleCourseData] = useState<any | null>(null);
  const [loading, setLoading] = useState(false);
  const [tabComponent, setTabComponent] = useState<
    "apply" | "callBack" | "tabs" | "share"
  >("tabs");

  const singleCourse = async () => {
    try {
      if (props.data.data !== null) {
        setLoading(true);
        const response = await getSingleCourse(
          props.data.data,
          "INR"
        );
        if (response) {
          setSingleCourseData(response?.data?.data);
        } else {
          console.log("Error");
        }
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (props.data.data !== "null") {
      singleCourse();
    }
    // eslint-disable-next-line
  }, [props.data.data]);

  const About = ({ data }: any) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
          padding: "0 2rem",
        }}
      >
        <Box sx={{ mb: 1 }}>
          <Typography
            fontSize="15px"
            color="#1C1F40"
            sx={{ lineHeight: "2.6" }}
          >
            {data}
          </Typography>
        </Box>
      </div>
    );
  };

  const Information = ({ data }: any) => {
    return (
      <div
        style={{
          display: "flex",
          gap: "1rem",
          flexDirection: "column",
          padding: "0 2rem",
        }}
      >
        <Box sx={{ mb: 1, display: "flex", flexDirection: "column" }}>
          <Typography fontWeight="600" fontSize="16px" gutterBottom>
            Discipline
          </Typography>
          {data?.discipline.map((ele: String) => (
            <Typography>{ele}</Typography>
          ))}
        </Box>
        <Box sx={{ mb: 1 }}>
          <Typography fontWeight="600" fontSize="16px" gutterBottom>
            Sub Discipline
          </Typography>
          {data?.subDiscipline.map((ele: String) => (
            <Typography>{ele}</Typography>
          ))}
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "2rem",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              mb: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap: "0.8rem",
            }}
          >
            <SchoolOutlinedIcon />
            <Typography
              color="#1C1F40"
              fontWeight="600"
              sx={{ fontSize: {lg:"1.25rem"} }}
            >
              {setWordCase(data?.university?.type)}
            </Typography>

            <Typography
              // fontWeight="600"
              sx={{fontSize:{xs:"12px",sm:"14px",md:"1rem"}}}
              gutterBottom
              color="#858585"
            >
              University type
            </Typography>
          </Box>
          <Divider
            orientation="vertical"
            variant="middle"
            flexItem
            sx={{ border: "2px solid #1C1F40", height: "85px" }}
          />
          <Box
            sx={{
              mb: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap: "0.8rem",
            }}
          >
            <img
              src={Images.readingBook}
              alt=""
              style={{ width: "1.8rem", height: "1.8rem" }}
            />

            <Typography
              color="#1C1F40"
              fontWeight="600"
              sx={{ fontSize: {lg:"1.25rem"} }}
            >
              {data?.university?.establishedYear}
            </Typography>

            <Typography
              // fontWeight="600"
              // fontSize="16px"
              gutterBottom
              color="#858585"
              sx={{fontSize:{xs:"12px",sm:"14px",md:"1rem"}}}
            >
              Established year
            </Typography>
          </Box>
        </Box>
      </div>
    );
  };
  const AdmissionRequirements = ({ data }: any) => {
    return (
      <div style={{ padding: "0 2rem" }}>
        <Grid container sx={{ ml: 1 }} spacing={1}>
          {data?.AdmissionsRequirements?.AcademicRequirements?.length > 0 ? (
            <Grid item xs={12}>
              <Box sx={{}}>
                <div className="AdmissionRequirements">
                  <Typography
                    style={{
                      fontFamily: "Inter",
                      fontWeight: "500",
                      fontSize: "16px",
                    }}
                  >
                    Academic requirements{" "}
                  </Typography>
                  <ul style={{ paddingLeft: "2%", margin: "0.4rem" }}>
                    {data?.AdmissionsRequirements?.AcademicRequirements.map(
                      (item: any, index: number) => (
                        <li>
                          <Typography key={index} sx={{fontSize:{xs:"13px",md:"15px"}}} gutterBottom>
                            {item?.testName}
                            {item?.minScore
                              ? "-  Minimum score " + item?.minScore
                              : "- Required"}
                          </Typography>
                        </li>
                      )
                    )}
                  </ul>
                </div>
              </Box>
            </Grid>
          ) : (
            ""
          )}
          {data?.AdmissionsRequirements?.LanguageRequirements ? (
            <Grid item xs={12}>
              <Box sx={{}}>
                <div style={{}}>
                  <Typography
                    sx={{
                      fontFamily: "Inter",
                      fontWeight: "500",
                      fontSize: "16px",
                      mb: 1,
                    }}
                  >
                    Language requirements{" "}
                  </Typography>
                  <ul style={{ paddingLeft: "2%", margin: "0.4rem" }}>
                    {data?.AdmissionsRequirements?.LanguageRequirements.map(
                      (item: any, index: number) => {
                        return (
                          <li>
                            <Typography
                              key={index}
                              gutterBottom
                              sx={{fontSize:{xs:"13px",md:"15px"}}}
                            >
                              {item?.testName}{" "}
                              {item?.minScore
                                ? "-  Minimum score " + item?.minScore
                                : ""}
                            </Typography>
                          </li>
                        );
                      }
                    )}
                  </ul>
                </div>
              </Box>
            </Grid>
          ) : (
            ""
          )}
          <Grid item xs={12}>
            <Box
              sx={{
                mt: 1,
              }}
            >
              <div>
                <Typography
                  sx={{
                    fontWeight: "500",
                    fontSize:"15px"
                  }}
                >
                  General requirements
                </Typography>
                <ul style={{ paddingLeft: "2%", margin: "0.4rem" }}>
                  {data?.AdmissionsRequirements?.generalRequirements.map(
                    (item: any, index: number) => {
                      return (
                        <li key={index} style={{ fontSize: "15px" }}>
                          {item}{" "}
                        </li>
                      );
                    }
                  )}
                </ul>
              </div>
            </Box>
          </Grid>
        </Grid>
      </div>
    );
  };
  const ApplicationDetails = ({ data }: any) => {
    return (
      <Box
        sx={{
          mt: 0,
          padding: "0 2rem",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            backgroundImage: `url(${Images.maskGroup})`,
            padding: "2rem",
            backgroundSize: "contain",
            width: {lg:"300px"},
          }}
        >
          <Typography color="#fff" fontSize="1.25rem">
            Application Fee -{" "}
            {data?.applicationDetails?.applicationFee !== "NaN"
              ? `${data?.currency?.symbol} ${parseInt(
                  data?.applicationDetails?.applicationFee
                )?.toLocaleString("en-US")}`
              : "Not available"}
          </Typography>
          {/* <a href={data?.applicationDetails?.applicationFeeLink} target="_blank" rel="noreferrer" style={{ cursor: "pointer", textDecoration: "none", color: "#797979", }}>
            <Typography sx={{
              flexWrap: "nowrap",
              height: "1.5rem",
              fontWeight: 600,
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}>{data?.applicationDetails?.applicationFeeLink}</Typography></a> */}
        </Box>
      </Box>
    );
  };
  const StartDates = ({ data }: any) => {
    return (
      <Box sx={{ mt: 0.5, padding: "0 2rem",height:{xs:"40vh",lg:"100%"} }}>
        <Grid item xs={12}>
          <Box style={{ paddingLeft: "2%", margin: "0.4rem" }}>
            {data?.startDate?.map((item: any, index: number) => {
              const deadlineMonth = item.deadlineMonth;
              return (
                <Box
                  sx={{
                    display: "flex",
                    gap: "2rem",
                    justifyContent: "center",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: "10px",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={Images.readingBook}
                      alt=""
                      style={{ width: "1.8rem", height: "1.8rem" }}
                    />
                    <Typography
                      sx={{
                        fontSize: {lg:"1.25rem"},
                        color: "#1C1F40",
                        fontWeight: "500",
                      }}
                    >
                      {monthNames[item.courseStartingMonth]}{" "}
                    </Typography>

                    <Typography color="#858585" sx={{xs:"0.8rem",md:"1rem"}}>Course Starting</Typography>
                  </Box>
                  <Box>
                    <TrendingFlatIcon
                      sx={{
                        // ml: 1,
                        color: "#3B3F76E5",
                        fontSize: "3.25rem",
                        cursor: "pointer",
                      }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      gap: "10px",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={Images.readingBook}
                      alt=""
                      style={{ width: "1.8rem", height: "1.8rem" }}
                    />

                    <Typography
                      sx={{
                        fontSize: {lg:"1.25rem"},
                        color: "#1C1F40",
                        fontWeight: "500",
                      }}
                    >
                      {deadlineMonth !== null
                        ? monthNames[deadlineMonth]
                        : "No deadline"}{" "}
                    </Typography>
                    <Typography color="#858585" sx={{xs:"0.8rem",md:"1rem"}}>
                      Application Deadline
                    </Typography>
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Grid>
      </Box>
    );
  };

  const tabs = [
    {
      label: "About ",
      Component: (
        <div style={{ }}>
          <About data={singleCourseData?.about} />
        </div>
      ),
    },
    {
      label: "Key Information",
      Component: (
        <div
          style={{
            overflowY: "scroll",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Information data={singleCourseData} />
          <ApplicationDetails data={singleCourseData} />
        </div>
      ),
    },
    {
      label: "Start dates & Deadlines",
      Component: (
        <div>
          <StartDates data={singleCourseData} />
        </div>
      ),
    },
    {
      label: "Admission Requirements",
      Component: (
        <Box
          sx={{ height: {lg:"55vh",xs:'100%'}, overflowY: "scroll", overflowX: "hidden", }}
        >
          <AdmissionRequirements data={singleCourseData} />
        </Box>
      ),
    },
  ];

  const data = [
    {
      key: "fees",
      value: (
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 600,
            margin: "2px 2px 0 0",
            position: "relative",
            cursor: "pointer",
            "&:hover .cancel-icon": {
              display: "block !important",
            },
          }}
        >
          {/* {singleCourseData?.tuitionFee?.tuitionFee
            ? singleCourseData?.currency?.symbol
            : ""}{" "} */}
          &nbsp;
          <span
            className="cancel-icon"
            style={{
              display: "none",
              color: "#000",
              position: "absolute",
              border: "1px solid #7d7d7d",
              width: "100px",
              zIndex: 1,
              fontSize: "12px",
              background: "#fff",
              textAlign: "center",
            }}
          >
            Currency :{singleCourseData?.currency?.code}
          </span>
          {singleCourseData?.tuitionFee?.tuitionFee || singleCourseData?.tuitionFee?.tuitionFee > 0
                    ? (
                        Math.round(singleCourseData?.tuitionFee?.tuitionFee * 100) / 100
                      ).toLocaleString("en-US")
                      
                    : "N/A"}
         {(singleCourseData?.tuitionFee?.tuitionFee || singleCourseData?.tuitionFee?.tuitionFee) > 0 && <span style={{ fontSize: "8px",marginLeft:"2px",fontWeight:"400" }}>
          (approx)
          </span> }
        </Typography>
      ),
      color: "#E7E8FF",
      label: `Tuition Fee (${singleCourseData?.currency?.symbol})`,
      bgColor: "#DDDEFF",
    },
    {
      key: "studyMode",
      value: singleCourseData?.studyMode?.join(", "),
      color: "#D6FBF9",
      bgColor: "#5FD1CB",
      label: "Study Mode",
    },
    {
      key: "duration",
      value: `${
        singleCourseData?.duration
          ? singleCourseData?.duration.reduce((acc:string,curr:any,i:number)=>(acc+(`${curr?.durationType}:${curr?.duration}`)+(i<singleCourseData?.duration?.length-1?",":"")),"") + " months"
          : "No data"
      }`,
      label: "Duration",
      color: "#E7E8FF",
      bgColor: "#DDDEFF",
    },
    {
      key: "Total Credits",
      value: singleCourseData?.totalCredits
        ? singleCourseData?.totalCredits
        : "No data",
      color: "#FFEACB",
      label: "Total Credits",
      bgColor: "#FFDFB0",
    },
    {
      key: "studyLevel",
      value: singleCourseData?.studyLevel,
      color: "#FFBEB5",
      bgColor: "#FF9081",
      label: "Study level",
    },

    {
      key: "applicationFee",
      value:
        singleCourseData?.applicationDetails?.applicationFee !== "NaN"
          ? `${singleCourseData?.currency?.symbol} ${parseInt(
              singleCourseData?.applicationDetails?.applicationFee
            )?.toLocaleString("en-US")}`
          : "N/A",
      label: "Application fee",
      color: "#FFEACB",
      bgColor: "#FFDFB0",
    },
  ];

  return (
    <div>
      {loading ? (
        <Typography textAlign="center" sx={{ height: "200px" }}>
          Loading...
        </Typography>
      ) : (
        <Grid container spacing={2} sx={{height:{xs: "70vh",lg:"100%"},overflowY:"scroll",p:2}}>
          <Grid
            item
            xs={12}
            md={4.5}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              // height: "100%",
              // overflowY:"scroll"
            }}
          >
            <Box sx={{}}>
              <Stack
                direction="column"
                sx={{ alignItems: "center", justifyContent: "center" }}
                spacing={3}
              >
                <Box
                  sx={{
                    marginTop: "8px !important",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 2,
                  }}
                >
                  <img
                    src={singleCourseData?.university?.logoSrc}
                    alt="logo"
                    style={{ borderRadius: "50%", height: "4rem" }}
                  />
                  <Typography
                    fontWeight="400"
                    sx={{
                      fontSize: { xs: "16px", lg: "20px" },
                      fontWeight: 500,
                      textTransform: "none",
                      textAlign: "center",
                      maxWidth: { lg: "25vw" },
                      color: "#3b3f76",
                      mt: 1,
                    }}
                  >
                    {singleCourseData?.name}
                  </Typography>
                  <Stack direction="row" spacing={1}>
                    {singleCourseData?.stemDetails?.stem ? (
                      <Button
                        sx={{
                          color: "#FF751A",
                          background: "#FFDAA1",
                          borderRadius: "1rem",
                          fontSize: "10px",
                          p: 0,
                          minWidth: "3rem",
                          width:"2.9rem",
                          "&:hover": {
                            color: "#FF751A",
                            background: "#FFDAA1",
                          },
                        }}
                      >
                        STEM
                      </Button>
                    ) : (
                      ""
                    )}
                      {singleCourseData?.elite ? 
             <Button
             sx={{
               color: "#008EDC",
               background: "#9ADBFF",
               borderRadius: "1rem",
               fontSize: "10px",
               p: 0,
               // minWidth: "3rem",
               textTransform:"none",
               width:"3rem",
               "&:hover": {
                 color: "#008EDC",
                 background: "#9ADBFF",
               },
             }}
           >
             Elite
           </Button>
                  :
                 ""}
                      </Stack>
                  <Box
                    sx={{ display: "flex", gap: "1rem", alignItems: "center" }}
                  >
                    <Typography
                      fontSize="1rem"
                      fontWeight="500"
                      color="#3b3f76"
                      sx={{ my: 1, display: "flex" }}
                    >
                      {singleCourseData?.university?.name}
                    </Typography>
                    {!props.data.icon ? (
                      <span
                        style={{
                          color: "#3B3F76",
                          cursor: "pointer",
                          display: "flex",
                          gap: "1rem",
                        }}
                        onClick={() =>
                          props.data?.setInitialState("university")
                        }
                      >
                        <Box
                          sx={{
                            width: "1.8rem",
                            height: "1.8rem",
                            background: "#FFDFB0",
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <EastIcon
                            sx={{
                              // ml: 1,
                              color: "#3B3F76E5",
                              fontSize: "1.25rem",
                              cursor: "pointer",
                              transform: "rotate(325deg)",
                            }}
                          />
                        </Box>
                      </span>
                    ) : (
                      ""
                    )}
                  </Box>
                </Box>
                <Box sx={{ flexGrow: 1, width: "100%" }}>
                  <Grid container spacing={2} sx={{padding:{sm:"0 5rem",md:"0"} }}>
                    {data.map((item, index) => (
                      <Grid item  xs={6} md={6} lg={4} key={index}>
                        <Box
                          sx={{
                            background: item.color,
                            borderRadius: "20px",
                            // padding: "10px",
                            position: "relative",
                            px: 2,
                            py: 2.5,
                            height:{xs:"4rem",lg:"5rem"},width:{xs:"5rem",md:"6rem",lg:"auto"},
                            display:"flex",
                            flexDirection:'column',
                            justifyContent:"center"

                          }}
                        >
                          <Typography
                            fontSize="0.85rem"
                            fontWeight="500"
                            color="#1C1F40CC"
                            sx={{ display: "flex", gap: "5px" }}
                          >
                            {item.label}
                          </Typography>
                          <Typography
                            color="#1C1F40"
                            fontWeight="600"
                            fontSize="1rem"
                          >
                            {item.value}
                          </Typography>
                          {/* <p style={{
                            position: 'absolute',
                            right: '15px',
                            top: '60%', background: item.bgColor, width: "1rem", height: "1rem", margin: 0, borderBottomLeftRadius: "20px", transform: "rotate(65deg"
                          }}></p> */}

                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Stack>
            </Box>
          </Grid>
          <Grid item xs={12} md={7.5}>
            {tabComponent === "tabs" ? (
              ""
            ) : (
              <ArrowBack
                onClick={() => setTabComponent("tabs")}
                sx={{ cursor: "pointer" }}
              />
            )}
            {tabComponent === "tabs" ? (
              <CustomTabs tabs={tabs} />
            ) :""}
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default CourseDetailed;
